var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',_vm._g(_vm._b({ref:"modal",scopedSlots:_vm._u([{key:"modal-header-close",fn:function(){return [_c('span',{attrs:{"href":"#close"}},[_c('SvgIcon',{attrs:{"name":"components/close","width":"16","height":"16"}})],1)]},proxy:true},{key:"modal-footer",fn:function(ref){
var ok = ref.ok;
var cancel = ref.cancel;
return [_vm._t("footer",null,{"ok":ok,"cancel":cancel})]}}],null,true)},'b-modal',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }